import http from '@/utils/http';
import i18n from '@/main';

const baseUrl = '/sucursais';
const baseUrlPersonas = '/representantesSucursal';

export default {
    cadastrarSucursal(dados) {
        return http.post({
            url: baseUrl + '/inserirSucursais',
            data: dados,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.cadastrandoSucursal')
        });
    },
    editarSucursal(dados, idSucursal) {
        return http.put({
            url: baseUrl + `/editar-sucursais-revenda/${idSucursal}`,
            data: dados,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.editandoSucursal')
        });
    },
    listagemPaginada({ page = 0, filter = '', order = null }) {
        return http.get({
            url:
                baseUrl +
                `/listar?page=${page}&filter=${filter}&order=${order}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoSucursales')
        });
    },
    listagem() {
        return http.get({
            url: baseUrl + `/listar`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoSucursales')
        });
    },
    buscarSucursaisPorRevenda(idRevenda) {
        return http.get({
            url: baseUrl + `/listarSucursaisRevenda/${idRevenda}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoSucursales')
        });
    },
    totalizadores(body) {
        return http.post({
            url: baseUrl + '/totalizadores/sucursalAR',
            data: body,
            lockScreen: false
        });
    },
    listagemContratos(dados, params) {
        return http.post({
            url:
                baseUrl +
                `/sucursalAR?page=${params.page}&size=${params.size}&sort=${params.sort},${params.por}`,
            data: dados,
            lockScreen: false
        });
    },
    vizualizarContrato({ numeroContrato, idSucursal }) {
        return http.get({
            url: baseUrl + `/sucursalAR/visualizar/${numeroContrato}/${idSucursal}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoSucursales')
        });
    },
    territoriosNaoEnviados({ contrato, idSucursal, pagina, tamanho }) {
        return http.get({
            url:
                baseUrl +
                `/sucursalAR/${contrato}/${idSucursal}?page=${pagina}&size=${tamanho}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoTerritorios')
        });
    },
    verificaSePodeConcluirOContrato(numeroContrato, idSucursal) {
        return http.get({
            url: baseUrl + '/sucursalAR/verifica-concluir-ar/' + numeroContrato + '/' + idSucursal,
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.verificandoSeOContratoPodeSerConcluido'
            )
        });
    },
    concluirProcessamentoContrato({ contrato, idSucursal }) {
        return http.get({
            url: baseUrl + `/sucursalAR/concluir-processamento-ar/${contrato}/${idSucursal}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.concluindoProcessamento')
        });
    },
    buscarSaldo(idTerritorio, numeroContrato) {
        return http.get({
            url:
                baseUrl +
                `/sucursalAR/territorio/busca-saldo-ar?idTerritorio=${idTerritorio}&numeroContrato=${numeroContrato}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoInformacoes')
        });
    },
    buscarTerritoriosContrato({ contrato, idSucursal, pagina, tamanho }) {
        return http.get({
            url:
                baseUrl +
                `/sucursalAR/${contrato}/${idSucursal}?page=${pagina}&size=${tamanho}`,
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoTerritorios')
        });
    },
    inserirDadosContrato(body) {
        return http.post({
            url: baseUrl + '/sucursalAR/inserir',
            data: body,
            lockScreen: true,
            lockMessage: 'Salvando dados de contrato'
        });
    },
    uploadRecebimentosLote(planilha) {
        const formData = new FormData();
        formData.append('planilha', planilha.raw);

        return http.post({
            url: baseUrl + '/sucursalAR/recebimentos-lote/upload',
            data: formData,
            lockScreen: false,
            config: {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        });
    },
    realizarAnaliseElegibilidade(body) {
        return http.post({
            url: baseUrl + '/sucursalAR/analisar-elegibilidade',
            data: body,
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoInformacoes'),
            headers: {
                'Content-Type': 'application/json'
            }
        });
    },
    validarRaioLocalidade(data, lockScreen = false) {
        return http.post({
            url: baseUrl + '/sucursalAR/validar-localidade',
            data: data,
            lockScreen,
            lockMessage: i18n.t('mensagens.sistema.buscandoInformacoes')
        });
    },
    listagemPersonas({ page, size, order, searchText, sucursal }) {
        return http.get({
            url:
                baseUrlPersonas +
                `/filter?page=${page}&size=${size}${order}&searchText=${searchText}&sucursal=${sucursal}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoPessoas')
        });
    },
    cadastrarRepresentante(representante) {
        return http.post({
            url: baseUrlPersonas + '/inserirSucursalAR',
            data: { ...representante },
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.adicionandoPessoa')
        });
    },
    editarRepresentante(representante) {
        return http.put({
            url: baseUrlPersonas + '/update',
            data: { ...representante },
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.salvandoPessoaAtualizada')
        });
    },
    delete(representanteId) {
        return http.delete({
            url:
                baseUrlPersonas + `/remover?representanteId=${representanteId}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.removendoPessoa')
        });
    },
    changeEnabled(id, enabled) {
        return http.put({
            url: baseUrl + `/inativar-sucursal/${id}/${enabled}`,
            data: {},
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.atualizandoStatusDaSucursal')
        });
    }
};
